export default [
  {
    path: '/products',
    name: 'products',
    component: () => import('@/views/products/ProductsMain.vue'),
  },
  {
    path: '/products/create',
    name: 'products-create',
    component: () => import('@/views/products/ProductsCreate.vue'),
    meta: {transitionName: 'zoom'},
  },
  {
    path: '/products/create-calibrated',
    name: 'products-create-calibrated',
    component: () => import('@/views/products/ProductsCreate.vue'),
    meta: {transitionName: 'zoom'},
  },
  {
    path: '/products/create-plane',
    name: 'products-create-plane',
    component: () => import('@/views/products/ProductsCreate.vue'),
    meta: {transitionName: 'zoom'},
  },
  {
    path: '/products/create-rods',
    name: 'products-create-rods',
    component: () => import('@/views/products/ProductsCreate.vue'),
    meta: {transitionName: 'zoom'},
  },
  {
    path: '/products/create-binpick',
    name: 'products-create-binpick',
    component: () => import('@/views/products/ProductsCreate.vue'),
    meta: {transitionName: 'zoom'},
  },
  {
    path: '/products/create-boards',
    name: 'products-create-boards',
    component: () => import('@/views/products/ProductsCreate.vue'),
    meta: {transitionName: 'zoom'},
  },
  {
    path: '/products/create-unet',
    name: 'products-create-unet',
    component: () => import('@/views/products/ProductsCreate.vue'),
    meta: {transitionName: 'zoom'},
  },
  {
    path: '/products/create-monitoring',
    name: 'products-create-monitoring',
    component: () => import('@/views/products/ProductsCreate.vue'),
    meta: {transitionName: 'zoom'},
  },
  {
    path: '/products/create-other',
    name: 'products-create-other',
    component: () => import('@/views/products/ProductsCreate.vue'),
    meta: {transitionName: 'zoom'},
  },
  {
    path: '/products/edit/:id',
    name: 'products-edit',
    component: () => import('@/views/products/ProductsEdit.vue'),
    meta: {transitionName: 'slide'},
  },
];
